import styled from 'styled-components';
import { brandColors } from 'styles/colors';
import {
	ErrorIcon,
	CheckCircleIcon as OriginalCheckCircleIcon,
} from 'components/icons';

export const Wrapper = styled.span`
	position: fixed;
	top: 72px;
	right: 10px;
	outline: none;
	background: none;
	z-index: 999;
	width: 300px;
`;

export const Message = styled.div`
	top: 100px;
	align-items: center;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
	box-sizing: border-box;
	color: white;
	background: ${brandColors.green};
	display: flex;
	min-height: 26px;
	padding: 10px;
	transition: all 0.3s ease-in;
	width: 100%;
	font-weight: bold;
	margin-top: 10px;
	cursor: pointer;
`;

export const CheckCircleIcon = styled(OriginalCheckCircleIcon)`
	fill: white;
	font-size: 24px;
	margin-right: 10px;
`;
export const UnCheckCircleIcon = styled(ErrorIcon)`
	fill: white;
	font-size: 24px;
	margin-right: 10px;
`;
